import { render } from "./AppSidebarNavItem.vue?vue&type=template&id=1288c176"
import script from "./AppSidebarNavItem.vue?vue&type=script&lang=js"
export * from "./AppSidebarNavItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/viper/Projects/topway/topway-accounting-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__